/**
 * Plugin de MediaPipe para Vue
 * Precarga los modelos de detección facial al iniciar la app
 * Esto elimina el delay cuando el usuario abre FotoCropperBox por primera vez
 */
import { initDetector } from '@/utils/FaceDetection';

export function mediapipePlugin() {
  return {
    install: () => {
      // Precargar el detector en background sin bloquear la app
      // No usamos await para que sea no-bloqueante
      initDetector()
        .then(() => {
          if (process.env.NODE_ENV === 'development') {
            console.log('[MediaPipe Plugin] ✓ Modelos de face detection precargados exitosamente');
          }
        })
        .catch((error) => {
          console.error('[MediaPipe Plugin] ✗ Error al precargar modelos:', error);
          // No lanzamos el error para no bloquear la app
          // El detector se cargará on-demand si falla la precarga
        });
    },
  };
}
